import { ApiRequestService } from "services/ApiRequestService";

export const BulkImportService = {
    searchImports(microserviceKey, searchRequest) {
        return ApiRequestService.post(microserviceKey, "BulkImports/Search", searchRequest);
    },
    get(microserviceKey, id) {
        return ApiRequestService.get(microserviceKey, `BulkImports/${id}`);
    },
    uploadFile(microserviceKey, file, bulkImportTypeKey) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('bulkImportTypeKey', bulkImportTypeKey);

        return ApiRequestService.post(microserviceKey, 'BulkImports/Upload', formData);
    },
    getUpload(microserviceKey, bulkImportUploadId) {
        return ApiRequestService.get(microserviceKey, `BulkImports/Upload/${bulkImportUploadId}`);
    },
    getTypeColumns(microserviceKey, bulkImportTypeKey) {
        return ApiRequestService.get(microserviceKey, `BulkImports/Type/${bulkImportTypeKey}/Columns`);
    },
    submitMapping(microserviceKey, bulkImportUploadId, mappingPlan) {
        return ApiRequestService.post(microserviceKey, `BulkImports/Upload/${bulkImportUploadId}/Map`, { mappingPlan });
    }
};
